<template>
  <DashboardContentLayout>TenderGeneralCoPage</DashboardContentLayout>
</template>
